import { call, put, takeLatest } from 'redux-saga/effects';
import {
  handleLoginRequest,
  handleLoginSuccess,
  handleRegisterRequest,
  handleRegisterSuccess,
  // handleLogout,
  handleFailure,
  handleLogout,
  handleLogoutRequest,
  handleSuccess,
  handleForgotPassword,
  handleSaveUserData,
  handleSaveWalletData,
  handleNextPage,
  handleOtpRequest,
  handleCreateEmployeeRequest,
  handleEmployeeOtpRequest,
  handleEmployeeEmailRequest,
  handleEmployeeLoginRequest,
  handleEmployeeSteps,
  handleSaveCompanyId, handleSaveUserType, handleChangeSteps,
} from '../actions';
import {
  EmployeeLogin,
  EmployeeRegister,
  ForgotPassoword,
  Login,
  Otp,
  Register,
} from '../../Services/constant/serviceType';
import { registerUser, verifyOtp } from '../../Services/hooks/Register';
import { showToast } from '../constants/toastAction';
import { loginUser } from '../../Services/hooks/Login';
import { NavigateFunction } from 'react-router-dom';
import { PayloadAction } from '@reduxjs/toolkit';
import { purgeStoredState } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import { forgotPasswordMethod } from '../../Services/hooks/ForgotPassword';
import { getDashboardData } from '../../Services/hooks/Dashboard';
import { getWalletData } from '../../Services/hooks/wallet';
import {
  employeeEmail,
  loginEmployee,
  registerEmployee,
  verifyEmployeeOtp,
} from '../../Services/hooks/employeeRegister';


function* login(action: PayloadAction<{ payload: Login, navigate: NavigateFunction }>) {
  try {
    const { payload, navigate } = action.payload;
    const { success, data, error, user } = yield call(
      loginUser,
      payload,
      navigate,
    );
    console.log(success, data, error, user);
    if (success && user) {
      const email = user.email;
      const token = data;
      yield put(handleSaveUserType('admin'));
      yield put(handleLoginSuccess({ token, email }));
      yield put(handleSaveUserData(user));
      const id = user.id;
      console.log(id);
      yield call(
        getDashboardData,
        user.id,
      );
      yield put(showToast('Success', 'Login successful!', 'success'));

    } else {
      console.log('errorjjjj', error);
      yield put(handleFailure(error));
      yield put(showToast('Error', error, 'error'));
    }
    return success;
  } catch (error: any) {
    console.log(
      'Auth saga error:',
      error,
    );
    yield put(
      handleFailure(error.response?.data?.message || error.message),
    );
  }
}

function* register(action: PayloadAction<{ payload: Register }>) {
  const userError = null;
  try {
    const { payload } = action.payload;
    const { success, error, user } = yield call(
      registerUser,
      payload,
    );
    console.log(success, error, user, 'hggv');
    // userError = error;
    if (success) {
      const token = 'verified';
      const email = user.email;
      yield put(handleRegisterSuccess({ token }));
      // yield put(handleNextPage());
      yield put(handleLoginSuccess({ token, email }));
      yield put(showToast('Success', 'Registration successful!', 'success'));
    } else {
      yield put(handleFailure(error));
      yield put(showToast('Error', error, 'error'));
    }
    return success;
  } catch (errors: any) {
    console.log(
      'Auth saga error:',
      errors, userError,
    );
    yield put(
      handleFailure(errors.response?.data?.message || errors.message),
    );
  }
}

function* employeeEmailLogin(action: PayloadAction<{ payload: EmployeeLogin, navigate: NavigateFunction }>) {
  try {
    const { payload, navigate } = action.payload;
    const { success, data, error, user, id } = yield call(
      employeeEmail,
      payload,
      navigate,
    );
    console.log('bgdhh', success, data, error, id,  user);
    const email = user.email;
    const steps = 'otp';
    if (success && user) {
      yield put(handleEmployeeSteps({ steps, email }));
      yield put(handleSaveCompanyId(id));
      yield put(handleSuccess());
      yield put(showToast('Success', 'Otp sent', 'success'));

    } else {
      yield put(handleFailure(error));
      yield put(showToast('Error', error, 'error'));
    }
    return success;
  } catch (error: any) {
    console.log(
      'Auth saga error:',
      error.response?.data.message || error.message,
    );
    yield put(
      handleFailure(error.response?.data?.message || error.message),
    );
  }
}

function* postVerifyEmployeeOtp(action: PayloadAction<{ payload: Otp, navigate: NavigateFunction }>) {
  try {
    const { payload, navigate } = action.payload;
    const { success, error, user } = yield call(
      verifyEmployeeOtp,
      payload,
      navigate,
    );
    console.log(success, error, user);
    const email = user.email;
    const steps = 'create';
    if (success) {
      yield put(handleEmployeeSteps({ steps, email }));
      yield put(handleSuccess());
      yield put(showToast('Success', 'Otp verified successful!', 'success'));

    } else {
      yield put(handleFailure(error));
      yield put(handleNextPage());
      yield put(showToast('Error', error, 'error'));
    }
    return success;
  } catch (error: any) {
    console.log(
      'Auth saga error:',
      error.response?.data.message || error.message,
    );
    yield put(
      handleFailure(error.response?.data?.message || error.message),
    );
  }
}

function* employeeRegister(action: PayloadAction<{ payload: EmployeeRegister, navigate: NavigateFunction }>) {
  try {
    const { payload, navigate } = action.payload;
    const { success, error, user } = yield call(
      registerEmployee,
      payload,
      navigate,
    );
    console.log(success, error, user);
    if (success) {
      const token = 'verified';
      const email = user.email;
      yield put(handleSaveUserType('employee'));
      yield put(handleRegisterSuccess({ token }));
      yield put(handleSaveUserData(user));
      yield put(handleChangeSteps({ steps: 'email' }));
      yield put(handleLoginSuccess({ token, email }));
      yield put(showToast('Success', 'Registration successful!', 'success'));
    } else {
      yield put(handleFailure(error));
      yield put(showToast('Error', error, 'error'));
    }
    return success;
  } catch (error: any) {
    console.log(
      'Auth saga error:',
      error.response?.data.message || error.message,
    );
    yield put(
      handleFailure(error.response?.data?.message || error.message),
    );
  }
}

function* employeeLogin(action: PayloadAction<{ payload: Login, navigate: NavigateFunction }>) {
  try {
    const { payload, navigate } = action.payload;
    const { success, data, error, user } = yield call(
      loginEmployee,
      payload,
      navigate,
    );
    console.log(success, data, error, 'hhh', user);
    const email = user.email;
    const token = data;
    yield put(handleSaveUserData(user));

    yield put(handleLoginSuccess({ token, email }));

    if (success && user) {
      yield put(handleSaveUserType('employee'));
      yield put(showToast('Success', 'Login successful!', 'success'));

    } else {
      yield put(handleFailure(error));
      yield put(showToast('Error', error, 'error'));
    }
    return success;
  } catch (error: any) {
    console.log(
      'Auth saga error:',
      error.response?.data.message || error.message,
    );
    yield put(
      handleFailure(error.response?.data?.message || error.message),
    );
  }
}

function* postVerifyOtp(action: PayloadAction<{ payload: Otp, navigate: NavigateFunction }>) {
  try {
    const { payload, navigate } = action.payload;
    const { success, data, error, user } = yield call(
      verifyOtp,
      payload,
      navigate,
    );
    console.log(success, data, error, user);
    // const token = data;
    yield put(handleSaveUserType('admin'));
    yield put(handleNextPage());
    yield put(handleSuccess());

    yield put(handleSaveUserData(user));
    if (success && user) {
      const id = user.id;
      console.log(id);
      const { success: success1 } = yield call(
        getDashboardData,
        user.id,
      );
      const { result: wallet } = yield call(
        getWalletData,
        user.id,
      );
      yield put(handleSaveWalletData(wallet));
      console.log('walletsaga', wallet, success1);
      yield put(showToast('Success', 'Login successful!', 'success'));

    } else {
      yield put(handleFailure(error));
      yield put(handleNextPage());
      yield put(showToast('Error', error, 'error'));
    }
    return success;
  } catch (error: any) {
    console.log(
      'Auth saga error:',
      error.response?.data.message || error.message,
    );
    yield put(
      handleFailure(error.response?.data?.message || error.message),
    );
  }
}

function* forgotPassword(action: { payload: ForgotPassoword }) {
  try {
    const { success, data, error } = yield call(
      forgotPasswordMethod,
      action.payload,
    );
    console.log(success, data, error, 'hhhf');
    if (success) {
      yield put(handleSuccess());
      yield put(showToast('Success', 'Registration successful!', 'success'));
    } else {
      yield put(handleFailure(error));
      yield put(showToast('Error', error, 'error'));
    }
  } catch (error: any) {
    console.log(
      'Auth saga error:',
      error.response?.data.message || error.message,
    );
    yield put(
      handleFailure(error.response?.data?.message || error.message),
    );
  }
}

function* logout() {
  try {
    yield purgeStoredState({
      key: 'root',
      storage,
    });
    yield put(handleLogout());
  } catch (error) {
    console.error('Error deleting token', error);
  }
}

function* watchAuthActions() {
  yield takeLatest(handleLoginRequest, login);
  yield takeLatest(handleRegisterRequest, register);
  yield takeLatest(handleCreateEmployeeRequest, employeeRegister);
  yield takeLatest(handleEmployeeEmailRequest, employeeEmailLogin);
  yield takeLatest(handleEmployeeLoginRequest, employeeLogin);
  yield takeLatest(handleForgotPassword, forgotPassword);
  yield takeLatest(handleOtpRequest, postVerifyOtp);
  yield takeLatest(handleEmployeeOtpRequest, postVerifyEmployeeOtp);
  yield takeLatest(handleLogoutRequest, logout);
}
export default watchAuthActions;
